import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from '../../../branding';
import { Translate } from '../../../services';
import cn from 'classnames';
import './styles.less';
import Certificate from '../certificate';
import classNames from 'classnames';
import LearningItemActionButton from './LearningItemActionButton';
import { PaperIcon } from '@nackle/paper';
import StatusIcon from '../../status/Status';

const LearningCardItem = ( { dataAccessor, className, isLoading } ) => {
    const theme = useContext( ThemeContext );
    const classBase = 'learning-card-item';

    return (
        <div className={ cn( className, classBase, `${ classBase }-${ dataAccessor.__type }`, { locked: dataAccessor?.prerequisiteData?.locked } ) } >
            <div className='click-overlay' onClick={ dataAccessor?.onClick } />
            { dataAccessor?.getThumbnail === undefined && dataAccessor.getIcon ?
                    <div className={ `image-content ${ dataAccessor?.__type } icon` }>
                        { dataAccessor.getIcon() }
                        { dataAccessor?.prerequisiteData?.locked &&
                            <div className='overlay'><PaperIcon collection='ultimate' icon='Lock4' svgProps={ { width: '40px', height: '40px' } } /></div>
                        }
                    </div>
                : theme !== 'seiko' ?
                    <div className={ `image-content ${ dataAccessor?.__type } ${ dataAccessor?.tags.includes( 'SEIKO Employee HLC' ) ? 'white-bg' : '' }` }>
                        <img src={ dataAccessor?.getThumbnail( theme ) }/>
                        { dataAccessor?.prerequisiteData?.locked &&
                            <div className='overlay'><PaperIcon collection='ultimate' icon='Lock4' svgProps={ { width: '60px', height: '60px' } } /></div>
                        }
                    </div>
                :
                    <>
                        <img
                            src={ dataAccessor?.getThumbnail( theme ) }
                            maskSrc={ '/images/seiko-course-image-mask.svg' }
                            className={ `${ classBase }-image` }
                            width="100%"
                            height="200"
                            preserveAspectRatio="xMidYMid slice"
                        /> 
                        { dataAccessor?.prerequisiteData?.locked &&
                            <div className='overlay'><PaperIcon collection='ultimate' icon='Lock4' svgProps={ { width: '60px', height: '60px' } } /></div>
                        }
                    </>
            }
            <div className='progress-bar' >
                <div className={ classNames( 'progress-bar-fill', 'primary-fill' ) } style={ { width: `${ ( dataAccessor?.prerequisiteData?.locked ? 0 : dataAccessor?.progress ?? 0 ) }%` } } />
            </div>
            <div className={ `${ classBase }-body` }>
                
                <div className={ `${ classBase }-content` } >
                    { !isLoading && 
                    <>
                        { dataAccessor?.typeText && 
                            <Translate.Text 
                                className={ classNames( 'learning-type', '_mini', '_subtitle' ) } 
                                value={ dataAccessor.typeText } 
                            /> 
                        }
                    
                        <span className='title _title line-clamp-2'>
                            { dataAccessor?.displayName }
                        </span>
                    
                        <div className='description _body line-clamp-4'>
                            { dataAccessor?.prerequisiteData?.locked && dataAccessor?.prerequisiteData?.prerequisites ? 
                                <span className='locked-message _subtitle'>
                                    <PaperIcon collection='ultimate' icon='Lock4' />
                                    <div className='line-clamp-4'>
                                        { 
                                            dataAccessor.__type == 'course' ? <Translate.Text value='locked.message.course'/>  
                                                : dataAccessor.__type == 'curriculum' ? <Translate.Text value='locked.message.curriculum'/> : <></>
                                        }
                                    </div>
                                </span> 
                                : <span dangerouslySetInnerHTML={ { __html: dataAccessor?.description ?? '' } } /> 
                            }
                            
                        </div>
                    </>
                    }
                    
                </div>
                <div className='action-link'>
                    <LearningItemActionButton dataAccessor={ dataAccessor } classBase={ classBase } isLoading={ isLoading } />
                    { !dataAccessor?.prerequisiteData?.locked &&
                        <StatusIcon status={ dataAccessor?.status } />
                    }
                </div>
                
                { ( dataAccessor?.hasCertificate && !dataAccessor?.prerequisiteData?.locked ) &&
                    <div className='action-additional'>
                        <Certificate isEarned={ dataAccessor.completed } fetchCertificateUrl={ dataAccessor.fetchCertificateUrl }/>
                    </div>
                }
            </div>
        </div>
    );
};

LearningCardItem.propTypes = {
    dataAccessor: PropTypes.object,
    className: PropTypes.string,
    isLoading: PropTypes.bool,
};

LearningCardItem.defaultProps = {
    dataAccessor: null,
    isLoading: false,
    className: '',
};

export default LearningCardItem;